import $, { event } from "jquery";
import 'bootstrap';
import "slick-carousel";
import "select2";
import './styles/index.scss';
import '../node_modules/lightbox2/dist/js/lightbox'



// НАСТРОЙКА СКРОЛА БУРГЕР МЕНЮ
const body = document.body;
const hamb = document.querySelector("#cheket");

hamb.addEventListener("click", hambHandler);
function hambHandler(e) {
  body.classList.toggle("noscroll");
}

// НАСТРОЙКА СЕЛЕКТА
const select = document.querySelector(".selected");
const optionsContainer = document.querySelector(".options-container");
const optionsList = document.querySelectorAll(".option");

if (select && optionsContainer && optionsList) {
  select.addEventListener("click", () => {
    optionsContainer.classList.toggle("active");
  });
  
  optionsList.forEach(o => {
    o.addEventListener("click", () => {
      select.innerHTML = o.querySelector("label").innerHTML;
      optionsContainer.classList.remove("active");
    });
  });
}

// НАСТРОЙКА СЛАЙДЕРА 

$(".scroling").slick( {
  infinite: true,
  slidesToShow: 15,
  slidesToScroll: 15
});


// НАСТРОЙКА ФИЛЬТРАЦИИ КАРТОЧЕК
const buttons = document.querySelectorAll('button')
console.log(buttons)
const cards = document.querySelectorAll('.card')

function filter(category, items) {
  items.forEach((item) => {
    const isItemFiltered = item.dataset.filterCard !== category
    const isShowAll = category === 'all'

    item.classList.remove('hide')

    if (isItemFiltered && !isShowAll) {
      item.classList.toggle('hide')
    }
  })
}

buttons.forEach((button) => {
  button.addEventListener('click', () => {
    console.log('click: ', button)
    const currentCategory = button.dataset.filterButton

    if (!currentCategory) {
      return
    }

    filter(currentCategory, cards)
  })
})

// НАСТРОЙКА ЦВЕТА СЕРДЕЧКА
$( ".tumble" ).on('click', function() {
  $(this).toggleClass( "active")
});

// НАСТРОЙКА ГРАФИКА 

import ApexCharts from 'apexcharts'
		
var options = {
  chart: {
    height: 200,
    width: "100%",
    margin: 0,
    type: "area",
    animations: {
      initialAnimation: {
        enabled: false
      }
    }
  },
  series: [
    {
      name: "Series 1",
      data: [
        [1486684800000, 34], 
        [1486771200000, 43], 
        [1486857600000, 31] , 
        [1486944000000, 43], 
        [1487030400000, 33], 
        [1487116800000, 52]
      ]
    }
  ],
  xaxis: {
    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
  }
  
};
var chart = new ApexCharts(document.querySelector("#chart"), options);
if (chart.el) {
  chart.render();
}


// НАСТРОЙКА СЛАЙДЕРА REVIEWS

$('.carousel').slick({
  dots: true,
  infinite: true,
  swipe:false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  // centerMode: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// НАСТРОЙКА СЛАЙДЕРА PRPICE


$('.netus').slick({
  centerMode: true,
  slidesToShow: 1,

  variableWidth: true,

 
});
 


// НАСТРОЙКА showMore

$(document).ready(function(){
  // $("#lmbutton").click(function(e){
  $(".lmbutton").click(function(e){
    e.preventDefault();
    // $(".card:hidden").slice(0,6).fadeIn("slow");
    const $button = $(this)
    const $parent = $button.closest('.container')
    const hiddenChildCards = $parent.find(".card:hidden")

    hiddenChildCards.slice(0,6).fadeIn("slow")
  
    // if($(".card:hidden").length == 0){
    if (hiddenChildCards.length == 6) {
      //  $("#lmbutton").fadeOut("slow");
      $button.fadeOut("slow");
    }
  });
})


// ОЧИСТКА ТЕКСТА В INPUT

$('#clear-btn').on('click', function(e){
  e.preventDefault();
  
  var val = $('#text1').val();
  
  if(val.length >= 1){
    $('#text1').val('');
  }
});

// КОПИРОВАНИЯ ТЕКСТА ПРИ НАЖАТИИ

const clickBoard = document.querySelector('#clickboardInput')
if (clickBoard){
  clickBoard.onclick = () => {
    navigator.clipboard.writeText('https://www.google.com/')
    successMessage.classList.add('active')
    setTimeout(() => successMessage.classList.remove('active'), 2000)
  }
}
  